module.exports = __webpack_public_path__ + "img/icon-error.dfdc156d.png";